import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { HotkeysService } from '@app/core/services/hotkeys.service';
import {
  CreatePlaylistDynamicFailure,
  CreatePlaylistDynamicRequest,
  CreatePlaylistDynamicSuccess,
  CreatePlaylistManualFailure,
  CreatePlaylistManualRequest,
  CreatePlaylistManualSuccess,
  EditPlaylistDynamicFailure,
  EditPlaylistDynamicRequest,
  EditPlaylistDynamicSuccess,
  EditPlaylistManualFailure,
  EditPlaylistManualRequest,
  EditPlaylistManualSuccess,
} from '@app/library/states/playlists.actions';
import {
  TrackEditFailure,
  TrackEditRequest,
  TrackEditSuccess,
  TrackTagsSaveFailure,
  TrackTagsSaveRequest,
  TrackTagsSaveSuccess,
} from '@app/library/states/tracks.actions';
import { UiStoreHelperService } from '@radioking/shared/common-services';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'rk-sidenav-action-wrapper',
  templateUrl: './sidenav-action-wrapper.component.html',
  styleUrls: ['./sidenav-action-wrapper.component.scss'],
})
export class SidenavActionWrapperComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('container')
  container: ElementRef<HTMLDivElement>;
  @Input()
  title: string;

  @Input()
  cancelText: string;

  @Input()
  submitText: string;

  @Input()
  disabledSubmit = false;

  @Input()
  showLinkForCancel = false;

  @Input()
  hideBottom = false;

  @Input()
  isContentLoading$: Observable<boolean>;

  @Input()
  enableScrollbar = true;

  @Input()
  actionRequest: any[] = [];

  @Input()
  actionDone: any[] = [];

  @Output()
  readonly cancelled = new EventEmitter();

  @Output()
  readonly actionInsteadOfCancel = new EventEmitter();

  @Output()
  readonly submitted = new EventEmitter();

  @ViewChild('mainContent', { static: true })
  mainContent: ElementRef;

  @Input()
  isSaving$: Observable<boolean>;

  windowHeight = window.innerHeight;
  subscription = new Subscription();

  constructor(
    private readonly uiHelper: UiStoreHelperService,
    private readonly cdr: ChangeDetectorRef,
    private readonly hotkeys: HotkeysService,
  ) {}

  ngOnInit() {
    if (!this.isSaving$) {
      this.isSaving$ = this.uiHelper.getLoadingState(
        [
          TrackEditRequest,
          TrackTagsSaveRequest,
          CreatePlaylistManualRequest,
          CreatePlaylistDynamicRequest,
          EditPlaylistManualRequest,
          EditPlaylistDynamicRequest,
          ...this.actionRequest,
        ],
        [
          TrackEditSuccess,
          TrackEditFailure,
          TrackTagsSaveSuccess,
          TrackTagsSaveFailure,
          CreatePlaylistManualSuccess,
          CreatePlaylistManualFailure,
          CreatePlaylistDynamicSuccess,
          CreatePlaylistDynamicFailure,
          EditPlaylistManualSuccess,
          EditPlaylistManualFailure,
          EditPlaylistDynamicSuccess,
          EditPlaylistDynamicFailure,
          ...this.actionDone,
        ],
      );
    }

    if (this.isContentLoading$) {
      this.subscription.add(
        this.isContentLoading$.subscribe(data => {
          if (data && this.mainContent) {
            this.mainContent.nativeElement.scrollTop = 0;
          }
        }),
      );
    }

    // Hotkeys
    this.subscription.add(
      this.hotkeys.fromConfigArray([
        {
          hotkey: 'cancel',
          override: { disabledOnOpenedPanel: false },
          handler: () => this.onCancelHotkey(),
        },
        { hotkey: 'confirm', handler: () => this.onConfirmHotkey() },
      ]),
    );
  }

  onCancelHotkey() {
    this.cancelled.emit();
  }

  ngAfterViewInit(): void {
    this.getWindowHeight();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getWindowHeight(): void {
    this.windowHeight = window.innerHeight;
    this.cdr.detectChanges();
  }

  onConfirmHotkey() {
    if (!this.disabledSubmit) {
      this.submitted.emit();
    }
  }
}
